import { Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { formatDateForUI, getServiceTypeString, handleAcceptAppointment, viewChat, capitalize, getStatusColor } from '../appointment/appointmentFunctions';
import ChatButton from '../buttons/Chat_button.svg';
import { ProfileIcon } from '../UserManagement/ProfileIcon.tsx';
import { calculateAge, formatPhoneNumber } from '../common';
import { joinUserRoom, markRead } from '../matrix/matrixFuntions.js';

export default function StaffAppointmentDetails({ showApptDetails, handleApptDetailsClose, selectedAppointment, loggedInUser, dispatch, serviceTypes, practiceId, token }) {

    var apptServiceType = "";
    if (selectedAppointment && selectedAppointment.appointment_basic_details) {
        apptServiceType = getServiceTypeString(selectedAppointment.appointment_basic_details.service_type, serviceTypes)
    }
    
    // Get matrixClient from Redux state
    const chatDetails = useSelector(state => state.chatDetails);
    const matrixClient = chatDetails.matrixClient;
    
    // Loading state for chat room creation
    const [isCreatingChatRoom, setIsCreatingChatRoom] = useState(false);
    return (
        <div>
            <Modal 
                id="appt-details" 
                show={showApptDetails} 
                onHide={handleApptDetailsClose} 
                size='xl'
                dialogClassName="w-full max-w-7xl mx-auto"
                contentClassName="bg-white rounded-lg"
            >
                <Modal.Header closeButton className="border-b border-gray-200 px-6 py-4">
                    <Modal.Title className="text-2xl font-semibold text-gray-800">View Appointment Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-6 py-4">
                    {selectedAppointment && (
                        <>
                            <div className="flex flex-col items-center mb-6">
                                <div className="mb-3 w-16 h-16"><ProfileIcon /></div>
                                <div className="text-xl font-semibold text-gray-800 text-center">
                                    {selectedAppointment.created_by_user.firstname + ' ' + selectedAppointment.created_by_user.lastname}
                                </div>
                                {selectedAppointment.appointment_basic_details.appointment_for === 'self' && (
                                    <div className="flex flex-col sm:flex-row gap-4 mt-2 text-center sm:text-left">
                                        <div className="text-sm font-medium text-gray-600">Gender: {selectedAppointment.created_by_user.gender}</div>
                                        <div className="text-sm font-medium text-gray-600">Age: {calculateAge(new Date(selectedAppointment.created_by_user.dateOfBirth))} years</div>
                                    </div>
                                )}
                            </div>
                            
                            <div className="space-y-6">
                                <div className="border-b border-gray-200 pb-6">
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                        <div>
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Requested On</div>
                                            <div className="text-base font-medium text-gray-800">{formatDateForUI(selectedAppointment.appointment_basic_details.create_date_time)}</div>
                                        </div>
                                        <div>
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Urgency</div>
                                            <div className="text-base font-medium text-gray-800">{selectedAppointment.appointment_basic_details.urgency_type}</div>
                                        </div>
                                        <div>
                                            {selectedAppointment.appointment_basic_details.appointment_for !== 'self' && (
                                                <>
                                                    <div className="text-sm font-semibold text-gray-500 mb-2">Appointment For</div>
                                                    <OverlayTrigger 
                                                        trigger={["hover", "focus", "click"]} 
                                                        placement='auto'
                                                        overlay={
                                                            <Popover id='tooltip-password'>
                                                                <Popover.Header className="bg-gray-100 border-b border-gray-200 font-semibold">Dependent Details</Popover.Header>
                                                                <Popover.Body className="text-sm">
                                                                    <p>Name: {selectedAppointment.dependent_details.firstname + ' ' + selectedAppointment.dependent_details.lastname}</p>
                                                                    <p>Age: {selectedAppointment.dependent_details.age}</p>
                                                                    <p>Gender: {selectedAppointment.dependent_details.gender}</p>
                                                                </Popover.Body>
                                                            </Popover>
                                                        }
                                                    >
                                                        <div className="text-base font-medium text-gray-800 cursor-pointer hover:text-blue-600">
                                                            {capitalize(selectedAppointment.appointment_basic_details.appointment_for)}
                                                        </div>
                                                    </OverlayTrigger>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="border-b border-gray-200 pb-6">
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                        <div>
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Department</div>
                                            <div className="text-base font-medium text-gray-800">{apptServiceType}</div>
                                        </div>
                                        <div>
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Symptoms</div>
                                            <div className="text-base font-medium text-gray-800">{selectedAppointment.appointment_basic_details.reason}</div>
                                        </div>
                                        <div>
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Insurance</div>
                                            <div className="text-base font-medium text-gray-800">-</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="border-b border-gray-200 pb-6">
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                        <div>
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Email</div>
                                            <div className="text-base font-medium text-gray-800 break-all">{selectedAppointment.created_by_user.email}</div>
                                        </div>
                                        <div>
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Phone Number</div>
                                            <div className="text-base font-medium text-gray-800">{formatPhoneNumber(selectedAppointment.created_by_user.phoneNum)}</div>
                                        </div>
                                        <div>
                                            <div className="text-sm font-semibold text-gray-500 mb-2">Zipcode</div>
                                            <div className="text-base font-medium text-gray-800">{selectedAppointment.zip_code}</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="pt-6">
                                    <div className="text-sm font-semibold text-gray-500 mb-4">Status</div>
                                    {selectedAppointment.nearest_practices && (
                                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                                            <div className={`px-4 py-2 rounded-md text-sm font-medium text-center ${getStatusColor(selectedAppointment.nearest_practices[0].practice_appointment_status)}`}>
                                                {selectedAppointment.nearest_practices[0].practice_appointment_status}
                                            </div>
                                            
                                            <div className="flex flex-col sm:flex-row items-center gap-2 mt-3">
                                                {isCreatingChatRoom ? (
                                                    // Loading state during room creation
                                                    <div className="flex items-center gap-2 px-3 py-2 bg-blue-100 rounded-md">
                                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                                                        <span className="text-sm text-blue-700 font-medium">Appointment accepting...</span>
                                                    </div>
                                                ) : (
                                                    <Link 
                                                        onClick={() => {
                                                            // If appointment is NEW, first accept it, then open chat
                                                            if (selectedAppointment.nearest_practices[0].practice_appointment_status === 'NEW') {
                                                                // Show loading state
                                                                setIsCreatingChatRoom(true);
                                                                
                                                                // Create a copy of the appointment to track updates
                                                                let appointmentCopy = { ...selectedAppointment };
                                                                
                                                                handleAcceptAppointment(appointmentCopy, loggedInUser, selectedAppointment.created_by_user._id, selectedAppointment.nearest_practices[0].service_id, selectedAppointment.nearest_practices[0].location_name, practiceId, dispatch,
                                                                    getServiceTypeString(selectedAppointment.appointment_basic_details.service_type, serviceTypes), token);
                                                                
                                                                // Wait for the appointment to be updated with matrix room info
                                                                setTimeout(() => {
                                                                    // The handleAcceptAppointment function updates the appointment's nearest_practices
                                                                    // with response data that includes the matrix room
                                                                    const updatedAppointment = appointmentCopy; // Now contains the updated room info
                                                                    
                                                                    console.log('Updated appointment after acceptance:', updatedAppointment);
                                                                    
                                                                    // Join the user to the Matrix room before opening chat
                                                                    const selectedRoom = updatedAppointment.nearest_practices[0].matrix_room_id;
                                                                    if (selectedRoom) {
                                                                        // Use the imported matrix client functions directly
                                                                        joinUserRoom(loggedInUser, matrixClient, selectedRoom);
                                                                        markRead(loggedInUser, matrixClient, selectedRoom);
                                                                        
                                                                        // Reset loading state and open chat with updated data
                                                                        setIsCreatingChatRoom(false);
                                                                        viewChat(updatedAppointment, loggedInUser, updatedAppointment.nearest_practices[0], dispatch);
                                                                        handleApptDetailsClose();
                                                                    } else {
                                                                        // Fallback: open chat without joining
                                                                        setIsCreatingChatRoom(false);
                                                                        viewChat(updatedAppointment, loggedInUser, updatedAppointment.nearest_practices[0], dispatch);
                                                                        handleApptDetailsClose();
                                                                    }
                                                                }, 1500); // Give time for the async operation to complete
                                                            } else {
                                                                // For other statuses, just open chat directly
                                                                viewChat(selectedAppointment, loggedInUser, selectedAppointment.nearest_practices[0], dispatch);
                                                                handleApptDetailsClose();
                                                            }
                                                        }}
                                                        className="hover:opacity-80 transition-opacity"
                                                    >
                                                        <img src={ChatButton} className='w-6 h-6 sm:w-7 sm:h-7' alt='Chat' />
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-t border-gray-200 px-6 py-4">
                    <div className="flex justify-center w-full">
                        <button 
                            className="px-8 py-3 bg-white border-2 border-teal-700 text-teal-700 font-medium rounded-md hover:bg-teal-50 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                            onClick={handleApptDetailsClose}
                        >
                            Close
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
}